import React from 'react'
import { DashboardBabyContentContainer } from './styles'
import { TimelineMaternalInfant } from '../../shared/TimelineMaternalInfant'
import { MaternalInfantSidePanel } from '../../shared/SidePanel'
import { NeonatalScreening } from '../../shared/NeonatalScreening'
import { BabyGrowth } from '../../shared/BabyGrowth'
import { Tabs } from '~/components/shared'
import { OpenCloseProvider } from '~/context'
import { message } from '~/services'
import { VaccinesProvider } from '~/context/vaccines'
import { Vaccines } from '~/components/generalMedicalView'
import { IPatient } from '~/interfaces'

interface IInfantTimelineViewProps {
  motherPatient: IPatient
  childPatient: IPatient
}

export const InfantTimelineView = ({ motherPatient, childPatient }: IInfantTimelineViewProps): JSX.Element => {
  return (
    <Tabs>
      <Tabs.Options>
        <Tabs.Item>{message('maternalInfant.timeline')}</Tabs.Item>
        <Tabs.Item>{message('maternalInfant.neonatal_screening')}</Tabs.Item>
        <Tabs.Item>{message('maternalInfant.baby_growth_title')}</Tabs.Item>
        <Tabs.Item>{message('timeline.vaccines')}</Tabs.Item>
      </Tabs.Options>

      <Tabs.Content>
        <DashboardBabyContentContainer>
          <OpenCloseProvider>
            <TimelineMaternalInfant />
            <MaternalInfantSidePanel />
          </OpenCloseProvider>
        </DashboardBabyContentContainer>

        <NeonatalScreening />

        <BabyGrowth motherPatient={motherPatient} childPatient={childPatient} />

        <VaccinesProvider>
          <Vaccines />
        </VaccinesProvider>
      </Tabs.Content>
    </Tabs>
  )
}
